/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Measures_EmptyInputs */

const en_us2_body_measures_empty = /** @type {(inputs: Body_Measures_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No measurements yet. With a tape measure, always measure at the same spot and the same time of day.`)
};

const pt_br2_body_measures_empty = /** @type {(inputs: Body_Measures_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma medida ainda. Com uma fita métrica, meça sempre no mesmo ponto e na mesma hora do dia.`)
};

const es_419_body_measures_empty = /** @type {(inputs: Body_Measures_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no hay medidas. Con una cinta métrica, mide siempre en el mismo punto y a la misma hora del día.`)
};

const pt_pt2_body_measures_empty = /** @type {(inputs: Body_Measures_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda não há medidas. Com uma fita métrica, mede sempre no mesmo ponto e à mesma hora do dia.`)
};

const fr_fr2_body_measures_empty = /** @type {(inputs: Body_Measures_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune mensuration pour l'instant. Avec un mètre ruban, mesure toujours au même endroit et à la même heure.`)
};

const de_de2_body_measures_empty = /** @type {(inputs: Body_Measures_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Umfänge. Miss mit dem Maßband immer an derselben Stelle und zur selben Tageszeit.`)
};

const it_it2_body_measures_empty = /** @type {(inputs: Body_Measures_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora nessuna misura. Con un metro da sarto, misura sempre nello stesso punto e alla stessa ora del giorno.`)
};

/**
* | output |
* | --- |
* | "No measurements yet. With a tape measure, always measure at the same spot and the same time of day." |
*
* @param {Body_Measures_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_measures_empty = /** @type {((inputs?: Body_Measures_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Measures_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_measures_empty(inputs)
	if (locale === "es-419") return es_419_body_measures_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_body_measures_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_body_measures_empty(inputs)
	if (locale === "de-DE") return de_de2_body_measures_empty(inputs)
	if (locale === "it-IT") return it_it2_body_measures_empty(inputs)
	return en_us2_body_measures_empty(inputs)
});
export { body_measures_empty as "body-measures.empty" }